"use strict";
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoteApi = exports.QuoteApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
// @ts-ignore
const models_1 = require("../models");
// @ts-ignore
const models_2 = require("../models");
// @ts-ignore
const models_3 = require("../models");
// @ts-ignore
const models_4 = require("../models");
// @ts-ignore
const models_5 = require("../models");
/**
 * QuoteApi - axios parameter creator
 * @export
 */
const QuoteApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} quoteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelQuote: async (quoteId, options = {}) => {
            // verify required parameter 'quoteId' is not null or undefined
            (0, common_1.assertParamExists)('cancelQuote', 'quoteId', quoteId);
            const localVarPath = `/api/quote/cancel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (quoteId !== undefined) {
                localVarQueryParameter['quote_id'] = quoteId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} quoteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadQuote: async (quoteId, options = {}) => {
            // verify required parameter 'quoteId' is not null or undefined
            (0, common_1.assertParamExists)('downloadQuote', 'quoteId', quoteId);
            const localVarPath = `/api/quote/{quoteId}.pdf`
                .replace(`{${"quoteId"}}`, encodeURIComponent(String(quoteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} quoteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuote: async (quoteId, options = {}) => {
            // verify required parameter 'quoteId' is not null or undefined
            (0, common_1.assertParamExists)('getQuote', 'quoteId', quoteId);
            const localVarPath = `/api/quote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (quoteId !== undefined) {
                localVarQueryParameter['quoteId'] = quoteId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} fromSuggestedDate
         * @param {string} toSuggestedDate
         * @param {number} [userId]
         * @param {Array<PlanningState>} [states]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuoteCommissionOverview: async (fromSuggestedDate, toSuggestedDate, userId, states, options = {}) => {
            // verify required parameter 'fromSuggestedDate' is not null or undefined
            (0, common_1.assertParamExists)('getQuoteCommissionOverview', 'fromSuggestedDate', fromSuggestedDate);
            // verify required parameter 'toSuggestedDate' is not null or undefined
            (0, common_1.assertParamExists)('getQuoteCommissionOverview', 'toSuggestedDate', toSuggestedDate);
            const localVarPath = `/api/quote/get-quote-commission-overview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (fromSuggestedDate !== undefined) {
                localVarQueryParameter['from_suggested_date'] = (fromSuggestedDate instanceof Date) ?
                    fromSuggestedDate.toISOString() :
                    fromSuggestedDate;
            }
            if (toSuggestedDate !== undefined) {
                localVarQueryParameter['to_suggested_date'] = (toSuggestedDate instanceof Date) ?
                    toSuggestedDate.toISOString() :
                    toSuggestedDate;
            }
            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }
            if (states) {
                localVarQueryParameter['states'] = states;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {RequestQuoteListBody} requestQuoteListBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuoteListPost: async (requestQuoteListBody, options = {}) => {
            // verify required parameter 'requestQuoteListBody' is not null or undefined
            (0, common_1.assertParamExists)('getQuoteListPost', 'requestQuoteListBody', requestQuoteListBody);
            const localVarPath = `/api/quote/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestQuoteListBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {QuoteRequestPeriod} period
         * @param {string} fromSuggestedDate
         * @param {string} [toSuggestedDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuoteOverviewPerUserPerPeriod: async (period, fromSuggestedDate, toSuggestedDate, options = {}) => {
            // verify required parameter 'period' is not null or undefined
            (0, common_1.assertParamExists)('getQuoteOverviewPerUserPerPeriod', 'period', period);
            // verify required parameter 'fromSuggestedDate' is not null or undefined
            (0, common_1.assertParamExists)('getQuoteOverviewPerUserPerPeriod', 'fromSuggestedDate', fromSuggestedDate);
            const localVarPath = `/api/quote/get-quote-overview-per-user-per-period`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }
            if (fromSuggestedDate !== undefined) {
                localVarQueryParameter['from_suggested_date'] = (fromSuggestedDate instanceof Date) ?
                    fromSuggestedDate.toISOString() :
                    fromSuggestedDate;
            }
            if (toSuggestedDate !== undefined) {
                localVarQueryParameter['to_suggested_date'] = (toSuggestedDate instanceof Date) ?
                    toSuggestedDate.toISOString() :
                    toSuggestedDate;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [fromCreatedDate]
         * @param {string} [toCreatedDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuoteStatusTotals: async (fromCreatedDate, toCreatedDate, options = {}) => {
            const localVarPath = `/api/quote/status-totals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (fromCreatedDate !== undefined) {
                localVarQueryParameter['from_created_date'] = (fromCreatedDate instanceof Date) ?
                    fromCreatedDate.toISOString() :
                    fromCreatedDate;
            }
            if (toCreatedDate !== undefined) {
                localVarQueryParameter['to_created_date'] = (toCreatedDate instanceof Date) ?
                    toCreatedDate.toISOString() :
                    toCreatedDate;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} quoteId
         * @param {IQuoteDataRating} iQuoteDataRating
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rateQuote: async (quoteId, iQuoteDataRating, options = {}) => {
            // verify required parameter 'quoteId' is not null or undefined
            (0, common_1.assertParamExists)('rateQuote', 'quoteId', quoteId);
            // verify required parameter 'iQuoteDataRating' is not null or undefined
            (0, common_1.assertParamExists)('rateQuote', 'iQuoteDataRating', iQuoteDataRating);
            const localVarPath = `/api/quote/rate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (quoteId !== undefined) {
                localVarQueryParameter['quote_id'] = quoteId;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iQuoteDataRating, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {IUpsertQuoteBody} iUpsertQuoteBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertQuote: async (iUpsertQuoteBody, options = {}) => {
            // verify required parameter 'iUpsertQuoteBody' is not null or undefined
            (0, common_1.assertParamExists)('upsertQuote', 'iUpsertQuoteBody', iUpsertQuoteBody);
            const localVarPath = `/api/quote/upsert-quote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUpsertQuoteBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.QuoteApiAxiosParamCreator = QuoteApiAxiosParamCreator;
/**
 * QuoteApi -
 */
var QuoteApi;
(function (QuoteApi) {
    /**
     *
     * @param {number} quoteId
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof QuoteApi
     * url /api/quote/cancel
     */
    async function cancelQuote(quoteId, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.QuoteApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.cancelQuote(quoteId, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            return res;
        });
    }
    QuoteApi.cancelQuote = cancelQuote;
    /**
     *
     * @param {number} quoteId
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof QuoteApi
     * url /api/quote/{quoteId}.pdf
     */
    async function downloadQuote(quoteId, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.QuoteApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.downloadQuote(quoteId, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            return res;
        });
    }
    QuoteApi.downloadQuote = downloadQuote;
    /**
     *
     * @param {number} quoteId
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof QuoteApi
     * url /api/quote
     */
    async function getQuote(quoteId, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.QuoteApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.getQuote(quoteId, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_3.parseIQuoteEntity)(res.data);
            return res;
        });
    }
    QuoteApi.getQuote = getQuote;
    /**
     *
     * @param {string} fromSuggestedDate
     * @param {string} toSuggestedDate
     * @param {number} [userId]
     * @param {Array<PlanningState>} [states]
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof QuoteApi
     * url /api/quote/get-quote-commission-overview
     */
    async function getQuoteCommissionOverview(fromSuggestedDate, toSuggestedDate, userId, states, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.QuoteApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.getQuoteCommissionOverview(fromSuggestedDate, toSuggestedDate, userId, states, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = res.data.map((x) => (0, models_2.parseIQuoteCommissionReportRow)(x));
            return res;
        });
    }
    QuoteApi.getQuoteCommissionOverview = getQuoteCommissionOverview;
    /**
     *
     * @param {RequestQuoteListBody} requestQuoteListBody
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof QuoteApi
     * url /api/quote/list
     */
    async function getQuoteListPost(requestQuoteListBody, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.QuoteApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.getQuoteListPost(requestQuoteListBody, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_1.parseBatchResponseIQuoteEntity)(res.data);
            return res;
        });
    }
    QuoteApi.getQuoteListPost = getQuoteListPost;
    /**
     *
     * @param {QuoteRequestPeriod} period
     * @param {string} fromSuggestedDate
     * @param {string} [toSuggestedDate]
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof QuoteApi
     * url /api/quote/get-quote-overview-per-user-per-period
     */
    async function getQuoteOverviewPerUserPerPeriod(period, fromSuggestedDate, toSuggestedDate, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.QuoteApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.getQuoteOverviewPerUserPerPeriod(period, fromSuggestedDate, toSuggestedDate, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = res.data.map((x) => (0, models_4.parseIQuoteOverviewPerUserPerPeriod)(x));
            return res;
        });
    }
    QuoteApi.getQuoteOverviewPerUserPerPeriod = getQuoteOverviewPerUserPerPeriod;
    /**
     *
     * @param {string} [fromCreatedDate]
     * @param {string} [toCreatedDate]
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof QuoteApi
     * url /api/quote/status-totals
     */
    async function getQuoteStatusTotals(fromCreatedDate, toCreatedDate, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.QuoteApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.getQuoteStatusTotals(fromCreatedDate, toCreatedDate, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = res.data.map((x) => (0, models_5.parseIQuoteStatusTotalsRow)(x));
            return res;
        });
    }
    QuoteApi.getQuoteStatusTotals = getQuoteStatusTotals;
    /**
     *
     * @param {number} quoteId
     * @param {IQuoteDataRating} iQuoteDataRating
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof QuoteApi
     * url /api/quote/rate
     */
    async function rateQuote(quoteId, iQuoteDataRating, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.QuoteApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.rateQuote(quoteId, iQuoteDataRating, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_3.parseIQuoteEntity)(res.data);
            return res;
        });
    }
    QuoteApi.rateQuote = rateQuote;
    /**
     *
     * @param {IUpsertQuoteBody} iUpsertQuoteBody
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof QuoteApi
     * url /api/quote/upsert-quote
     */
    async function upsertQuote(iUpsertQuoteBody, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.QuoteApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.upsertQuote(iUpsertQuoteBody, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_3.parseIQuoteEntity)(res.data);
            return res;
        });
    }
    QuoteApi.upsertQuote = upsertQuote;
})(QuoteApi || (exports.QuoteApi = QuoteApi = {}));
